export const PenaltyStatusTranslation = {
  new: 'Новый',
  agreed: 'Согласен',
  disagreed: 'Не согласен',
  canceled: 'Отменен',
  applied: 'Учтен',
}
